import { Box } from '@drone-js/core';
import styled from 'styled-components';

export const ResponsiveWrapper = styled(Box)`
    @media (min-width: 540px) {
        width: 60%;
    }

    @media (min-width: 1200px) {
        width: 70%;
    }
`;
